// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function prepareParenInts(wrkCtx, parenStr) {
  var parenSyms = Common.getSpaceSeparatedValuesAsArray(parenStr);
  var parenInts = [];
  var maxI = (parenSyms.length / 2 | 0) - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var leftParen = Caml_array.get(parenSyms, (i << 1));
    var rightParen = Caml_array.get(parenSyms, (i << 1) + 1 | 0);
    var leftParenInt = MM_context.ctxSymToInt(wrkCtx, leftParen);
    if (leftParenInt !== undefined && MM_context.isConst(wrkCtx, leftParen)) {
      var rightParenInt = MM_context.ctxSymToInt(wrkCtx, rightParen);
      if (rightParenInt !== undefined && MM_context.isConst(wrkCtx, rightParen)) {
        parenInts.push(leftParenInt);
        parenInts.push(rightParenInt);
      }
      
    }
    
  }
  return parenInts;
}

function lineToVarDef(line) {
  var arr = Common.getSpaceSeparatedValuesAsArray(line);
  if (arr.length !== 3) {
    return {
            TAG: /* Error */1,
            _0: "A line representing a variable definition should consist of exactly three parts separated with a whitespace."
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: arr
          };
  }
}

var newLineRegex = /[\n\r]/;

function textToVarDefs(text) {
  var varLines = text.split(newLineRegex).map(function (strOpt) {
          return Belt_Option.getWithDefault(strOpt, "").trim();
        }).filter(function (str) {
        return str.length > 0;
      });
  if (varLines.length === 0) {
    return {
            TAG: /* Ok */0,
            _0: []
          };
  } else {
    return varLines.reduce((function (res, line) {
                  if (res.TAG !== /* Ok */0) {
                    return res;
                  }
                  var varDefs = res._0;
                  var msg = lineToVarDef(line);
                  if (msg.TAG !== /* Ok */0) {
                    return {
                            TAG: /* Error */1,
                            _0: msg._0
                          };
                  }
                  varDefs.push(msg._0);
                  return {
                          TAG: /* Ok */0,
                          _0: varDefs
                        };
                }), {
                TAG: /* Ok */0,
                _0: []
              });
  }
}

function createWrkCtx(preCtx, varsText, disjText) {
  var wrkCtx = MM_context.createContext(Caml_option.some(preCtx), undefined, undefined);
  var err = [
      (function (param) {
          var msg = textToVarDefs(varsText);
          if (msg.TAG !== /* Ok */0) {
            return {
                    varsErr: msg._0,
                    disjErr: undefined
                  };
          }
          try {
            msg._0.forEach(function (varDef) {
                  MM_context.applySingleStmt(wrkCtx, {
                        TAG: /* Var */3,
                        symbols: [Caml_array.get(varDef, 2)]
                      });
                  MM_context.applySingleStmt(wrkCtx, {
                        TAG: /* Floating */5,
                        label: Caml_array.get(varDef, 0),
                        expr: [
                          Caml_array.get(varDef, 1),
                          Caml_array.get(varDef, 2)
                        ]
                      });
                });
            return ;
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === MM_parser.MmException) {
              return {
                      varsErr: exn._1.msg,
                      disjErr: undefined
                    };
            }
            throw exn;
          }
        }),
      (function (param) {
          try {
            Common.multilineTextToNonEmptyLines(disjText).forEach(function (param) {
                  return MM_context.applySingleStmt(wrkCtx, {
                              TAG: /* Disj */4,
                              vars: param.split(",").map(function (prim) {
                                    return prim.trim();
                                  })
                            });
                });
            return ;
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            if (exn.RE_EXN_ID === MM_parser.MmException) {
              return {
                      varsErr: undefined,
                      disjErr: exn._1.msg
                    };
            }
            throw exn;
          }
        })
    ].reduce((function (err, nextStep) {
          if (err !== undefined) {
            return err;
          } else {
            return Curry._1(nextStep, undefined);
          }
        }), undefined);
  if (err !== undefined) {
    return {
            TAG: /* Error */1,
            _0: err
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: wrkCtx
          };
  }
}

exports.prepareParenInts = prepareParenInts;
exports.textToVarDefs = textToVarDefs;
exports.createWrkCtx = createWrkCtx;
/* Common Not a pure module */
